var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7462 2.2531C10.9652 1.47206 9.69887 1.47206 8.91782 2.2531L8.18474 2.98618C7.9244 3.24653 7.50229 3.24653 7.24194 2.98618C6.98159 2.72583 6.98159 2.30372 7.24194 2.04337L7.97501 1.3103C9.27676 0.00854746 11.3873 0.00854746 12.6891 1.3103C13.9908 2.61204 13.9908 4.72259 12.6891 6.02434L10.0224 8.69101C8.72064 9.99276 6.61009 9.99275 5.30834 8.69101C5.04799 8.43066 5.04799 8.00855 5.30834 7.7482C5.56869 7.48785 5.9908 7.48785 6.25115 7.7482C7.0322 8.52925 8.29853 8.52925 9.07958 7.7482L11.7462 5.08153C12.5273 4.30048 12.5273 3.03415 11.7462 2.2531ZM7.74625 6.2531C6.9652 5.47206 5.69887 5.47206 4.91782 6.2531L2.25115 8.91977C1.4701 9.70082 1.4701 10.9671 2.25115 11.7482C3.0322 12.5292 4.29853 12.5292 5.07958 11.7482L5.81395 11.0138C6.0743 10.7535 6.49641 10.7535 6.75676 11.0138C7.01711 11.2742 7.01711 11.6963 6.75676 11.9566L6.02239 12.691C4.72064 13.9928 2.61009 13.9928 1.30834 12.691C0.00659433 11.3893 0.00659433 9.27871 1.30834 7.97696L3.97501 5.3103C5.27676 4.00855 7.38731 4.00855 8.68905 5.3103C8.9494 5.57064 8.9494 5.99275 8.68905 6.2531C8.42871 6.51345 8.00659 6.51345 7.74625 6.2531Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/WebsiteIcon.622e2ccb3f44b8de4ea1bbfbd2fe3fb5.svg";
export { ForwardRef as ReactComponent };